module.exports = __webpack_public_path__ + "img/logo.e5efc87c.svg";